import { AiOutlineArrowRight } from "react-icons/ai";
import "./HeaderStyle.css";
import { useState, useEffect } from "react";
import { whatsappLink } from "../../config/FirebaseConfig";
import { IoIosClose } from "react-icons/io";

export default function HeaderComponent() {
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredLogin, setIsHoveredLogin] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className={`nav_bar ${isScrolled ? "scrolled" : ""}`}>
      <div className="frameNav">
        <span
          className="logo_se77e"
          onClick={() => {
            window.location.href = "/";
          }}
          style={{ cursor: "pointer" }}
        >
          <img
            alt=""
            className="logo-desktop"
            src="../../assets/logo/SETTE-FIBRA2.png"
          />
        </span>
        {/* Desktop Links */}
        <span className="links">
          <span className="links-text">
            <a className="link" href="/" onClick={closeMenu}>
              Início
            </a>
            <a className="link" href="#plans" onClick={closeMenu}>
              Planos
            </a>
            <a className="link" href="#lancamentos" onClick={closeMenu}>
              Lançamentos
            </a>
            <a className="link" href="#advantage" onClick={closeMenu}>
              Vantagens
            </a>
            <a className="link" href="#app" onClick={closeMenu}>
              App
            </a>
            <a
              className="link"
              href="https://api.whatsapp.com/send/?phone=556240519377"
              onClick={closeMenu}
            >
              Atendimento
            </a>
          </span>
          <span className="buttons-header">
            <button
              className="buttonAssign"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                window.location.href = `${whatsappLink}`;
              }}
            >
              Assine já{" "}
            </button>
            <button
              className="buttonLogin"
              onMouseEnter={() => setIsHoveredLogin(true)}
              onMouseLeave={() => setIsHoveredLogin(false)}
              onClick={() => {
                window.location.href =
                  "https://ixc.se77e.com.br/central_assinante_web/login";
              }}
            >
              Central do Assinante{" "}
            </button>
          </span>
        </span>
        {/* Burger Icon for Mobile */}
        {!menuOpen && (
          <div className="burger-icon" onClick={toggleMenu} aria-label="Menu">
            <span />
            <span />
            <span />
          </div>
        )}
      </div>

      {/* Mobile Side Menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        {menuOpen && (
          <div className="close-icon" aria-label="Close Menu">
            <IoIosClose size={30} className="close-icon" onClick={closeMenu} />
          </div>
        )}
        <a className="link" href="/" onClick={closeMenu}>
          Início
        </a>
        <a className="link" href="#plans" onClick={closeMenu}>
          Planos
        </a>
        <a className="link" href="#lancamentos" onClick={closeMenu}>
          Lançamentos
        </a>
        <a className="link" href="#advantage" onClick={closeMenu}>
          Vantagens
        </a>
        <a className="link" href="#app" onClick={closeMenu}>
          App
        </a>
        <a
          className="link"
          href="https://api.whatsapp.com/send/?phone=556240519377"
          onClick={closeMenu}
        >
          Atendimento
        </a>
        <div className="buttons-header-mobile">
          <button
            className="buttonAssign"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
              window.location.href =
                "https://api.whatsapp.com/send/?phone=556240519377&text=Ol%C3%A1%21+Entrei+em+contato+atrav%C3%A9s+do+site+e+tenho+interesse+em+contratar+os+servi%C3%A7os.+%28n%C3%A3o+apague+esta+mensagem%29&type=phone_number&app_absent=0";
            }}
          >
            Assine já{" "}
            {isHovered && (
              <AiOutlineArrowRight fontSize={"1.8660812294182216vh"} />
            )}
          </button>
          <button
            className="buttonLogin"
            onMouseEnter={() => setIsHoveredLogin(true)}
            onMouseLeave={() => setIsHoveredLogin(false)}
            onClick={() => {
              window.location.href =
                "https://ixc.se77e.com.br/central_assinante_web/login";
            }}
          >
            Central do Assinante{" "}
            {isHoveredLogin && <AiOutlineArrowRight fontSize={17} />}
          </button>
        </div>
      </div>
      {/* Overlay */}
      {menuOpen && <div className="overlay" onClick={closeMenu} />}
    </div>
  );
}
